import { put, call, takeLatest } from 'redux-saga/effects';
import {
  SET_USER,
  GET_USER,
  UPDATE_USER_DATA,
  UPDATE_USER_AGREEMENTS,
} from '../redux/action/types';
import { areaApi } from '../utils/api';
import { setGlobalErrorVisibility } from '../redux/action';

function* getUserData() {
  try {
    const user = yield areaApi.getUserData();
    yield put({
      type: SET_USER,
      data: user.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* updateUserData(action) {
  try {
    let response = yield call(() => areaApi.updateUserData(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_USER,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* updateUserAgreements(action) {
  try {
    yield call(() => areaApi.updateUserAgreements(action.data.data));
    yield put({
      type: GET_USER,
    });
    action.data.onSuccess();
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* userSaga() {
  yield takeLatest(UPDATE_USER_DATA, updateUserData);
  yield takeLatest(UPDATE_USER_AGREEMENTS, updateUserAgreements);
  yield takeLatest(GET_USER, getUserData);
}

export default userSaga;
